import React from "react";

type sizeType = "lg" | "2x" | "3x" | "4x";

/**
 * symbol = name of icon class. E.g. for "icon-magnify" symbol should be "magnify"
 * size = possible values are "lg", "2x", "3x", "4x"
 * className = any extra classes you want to pass into
 */
type Props = {
    symbol: string;
    size?: sizeType;
    className?: string;
};

function Icon(props: Props) {
    const icon = "icon-" + props.symbol;
    const size = props.size ? " icon-" + props.size : "";
    const className = props.className ? " " + props.className : "";
    return <i className={icon + size + className} />;
}

export default Icon;
